import { produce } from "immer";
import {
  GET_JOURNEY_GRAPH,
  GET_JOURNEY_GRAPH_SUCCESS,
  GET_JOURNEY_GRAPH_FAILURE,
  SAVE_JOURNEY_GRAPH,
  SAVE_JOURNEY_GRAPH_SUCCESS,
  SAVE_JOURNEY_GRAPH_FAILURE,
  PUBLISH_JOURNEY_GRAPH,
  PUBLISH_JOURNEY_GRAPH_SUCCESS,
  PUBLISH_JOURNEY_GRAPH_FAILURE,
  VALIDATE_JOURNEY_GRAPH,
  VALIDATE_JOURNEY_GRAPH_SUCCESS,
  VALIDATE_JOURNEY_GRAPH_FAILURE,
} from "./constants";

export const initialState = {
  published: null,
  drafts: [],
  draft: null,
  templatesAvailable: [],
  revisions: [],
  headRevisionNumber: 0,
  isFetching: false,
  isSaving: false,
  isPublishing: false,
  isValidating: false,
  validationIssues: [],
  lastError: null,
};

// Pull the graph object out of an API response in either {data:{graph}} or {graph} shape.
const graphOf = (payload) => payload?.data?.graph ?? payload?.graph ?? null;

const upsertDraft = (draft, graph) => {
  if (!graph) return;
  draft.draft = graph;
  const idx = draft.drafts.findIndex((d) => d.id === graph.id);
  if (idx >= 0) draft.drafts[idx] = graph;
  else draft.drafts.unshift(graph);
  if (typeof graph.head_revision_number === "number") {
    draft.headRevisionNumber = graph.head_revision_number;
  }
};

const LocationJourneyGraphReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_JOURNEY_GRAPH:
        draft.isFetching = true;
        draft.lastError = null;
        break;
      case GET_JOURNEY_GRAPH_SUCCESS: {
        draft.isFetching = false;
        const data = action.payload?.data ?? action.payload ?? {};
        draft.published = data.published ?? null;
        draft.drafts = data.drafts ?? [];
        draft.templatesAvailable = data.templates_available ?? [];
        // Prefer an existing draft as the editable graph; else the published one.
        draft.draft = draft.drafts[0] ?? null;
        const active = draft.draft ?? draft.published;
        draft.headRevisionNumber = active?.head_revision_number ?? 0;
        break;
      }
      case GET_JOURNEY_GRAPH_FAILURE:
        draft.isFetching = false;
        break;

      case SAVE_JOURNEY_GRAPH:
        draft.isSaving = true;
        draft.lastError = null;
        break;
      case SAVE_JOURNEY_GRAPH_SUCCESS: {
        draft.isSaving = false;
        upsertDraft(draft, graphOf(action.payload));
        break;
      }
      case SAVE_JOURNEY_GRAPH_FAILURE:
        draft.isSaving = false;
        break;

      case PUBLISH_JOURNEY_GRAPH:
        draft.isPublishing = true;
        draft.lastError = null;
        draft.validationIssues = [];
        break;
      case PUBLISH_JOURNEY_GRAPH_SUCCESS: {
        draft.isPublishing = false;
        const graph = graphOf(action.payload);
        if (graph) {
          draft.published = graph;
          draft.drafts = draft.drafts.filter((d) => d.id !== graph.id);
          draft.draft = null;
          draft.revisions = [];
          draft.headRevisionNumber = 0;
        }
        break;
      }
      case PUBLISH_JOURNEY_GRAPH_FAILURE: {
        draft.isPublishing = false;
        draft.validationIssues = action.payload?.issues ?? [];
        draft.lastError = action.payload?.message ?? "Publish failed";
        break;
      }

      case VALIDATE_JOURNEY_GRAPH:
        draft.isValidating = true;
        break;
      case VALIDATE_JOURNEY_GRAPH_SUCCESS: {
        draft.isValidating = false;
        draft.validationIssues =
          action.payload?.data?.issues ?? action.payload?.issues ?? [];
        break;
      }
      case VALIDATE_JOURNEY_GRAPH_FAILURE:
        draft.isValidating = false;
        break;

      default:
        return state;
    }
  });

export default LocationJourneyGraphReducer;
